import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userSl, setUserSl] = useState('');
  const [authLoading, setAuthLoading] = useState(true);

  const login = () => setIsLoggedIn(true);
  const logout = () => setIsLoggedIn(false);

  useEffect(()=>{
    setUserSl(localStorage.getItem('userId'))
    if (localStorage.getItem('userId')>0) {
      setIsLoggedIn(true)
      setAuthLoading(false)
    }else{
      setIsLoggedIn(false)
      setAuthLoading(false)
    }
  },[userSl])

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout,userSl,setUserSl,authLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

